import { createReducer, on } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import { sessionAuthData } from '../../interfaces/states-data';
import { __clearSessionAuth, __updateSessionAuth } from './session-auth.actions';

const initialState: sessionAuthData = { loggedIn: false };

/**
 * Persistencia de `sessionAuthState` en localStorage.
 *
 * Vive en el reducer para que "despachar = persistir" sea atómico y haya UN solo
 * camino store → localStorage. Antes lo hacían cuatro suscriptores al store
 * (app.component, dos directivas de permisos y el guard de experiencia) y, como
 * `select` emite el valor actual al suscribirse, cada directiva que se
 * instanciaba escribía en localStorage el estado EN MEMORIA de su pestaña. En
 * una segunda pestaña ese estado eran tokens ya rotados por la primera, y al
 * pisarlos el próximo request salía con un access_token vencido y el refresh con
 * un refresh_token reutilizado → `REFRESH_TOKEN_REUSED` → logout de las dos
 * pestañas. Con la escritura acá, re-suscribirse al store ya no escribe nada.
 */
function persistSessionAuthState(state: sessionAuthData): void {
    try {
        localStorage.setItem('sessionAuthState', JSON.stringify(state));
    } catch {
        // localStorage lleno / bloqueado: el store en memoria sigue siendo válido.
    }
}

export const sessionAuthReducer = createReducer(
    initialState,
    immerOn(__updateSessionAuth, (state, action) => {
        const { type, ...newState } = action as any;
        const next = { ...newState } as sessionAuthData;
        persistSessionAuthState(next);
        return next;
    }),
    immerOn(__clearSessionAuth, (state, newState) => {
        // Borrar estado y tokens del local storage
        localStorage.removeItem('sessionAuthState');
        return { loggedIn: false };
    }),
)